import { AxiosError, isCancel } from "axios";

// Custom Error Types

export class MaxRetriesError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MaxRetriesError";
  }
}

/**
 * Whether a failed request deserves an error-level log. Only a server fault
 * (5xx) or an unreachable API does: a 4xx is the API answering and a
 * cancelled request is the page moving on.
 */
export const isReportableRequestError = (error: unknown): boolean => {
  if (isCancel(error)) return false;
  if (error instanceof AxiosError) {
    const status = error.response?.status;
    return status === undefined || status >= 500;
  }
  return true;
};
